/** Pure contract for Artemis staff access to the installer app. */
export const microsoftSignInOptions=(returnTo:string)=>({provider:'azure' as const,options:{scopes:'email openid profile',redirectTo:returnTo}});
